export default __webpack_public_path__ + "static/media/16-min.5310af48.jpg";